import { render, staticRenderFns } from "./MySignatures.component.vue?vue&type=template&id=21e628cc"
import script from "./MySignatures.component.vue?vue&type=script&lang=js"
export * from "./MySignatures.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports